<template>
  <li v-if="!item.onlyAdmin || role == 'admin'">
    <router-link
      :to="item.card ? item.card : '#'"
      :class="`${item.card ? (card == item.card ? 'active' : '') : ''}`"
      :style="item.tag ? 'pointer-events: none;' : ''"
    >
      <span>
        <div
          class="submenu-item-icon"
          v-if="item.iconSvg"
          v-html="item.iconSvg"
        ></div>

        <span>{{ item.title }}</span>

        <b-badge
          v-if="item.tag"
          variant="none"
          class="hp-text-color-black-100 hp-bg-success-3 rounded-pill px-8 border-0"
        >
          {{ item.tag }}
        </b-badge>
      </span>
    </router-link>
  </li>
</template>

<script>
import { BButton, BBadge } from "bootstrap-vue";

export default {
  props: ["item"],
  data() {
    return {
      card: "",
      role: this.$store.state.user['role'],
    };
  },
  components: {
    BButton,
    BBadge,
  },
  watch: {
    $route() {
      this.getRoute();
    },
  },
  created() {
    this.getRoute();
  },
  methods: {
    getRoute() {
      this.card = this.$route.params.card;
    },
  },
};
</script>
